var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix header-row",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "sam-order-search-form",
                  attrs: { inline: "", size: "small", "label-width": "138px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入订单号",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "orderNo", $$v)
                          },
                          expression: "listPram.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "第三方订单号" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入第三方订单号",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.outOrderSn,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "outOrderSn", $$v)
                          },
                          expression: "listPram.outOrderSn",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "第三方子订单号" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入山姆子订单号",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.childOrderSn,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "childOrderSn", $$v)
                          },
                          expression: "listPram.childOrderSn",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "山姆订单号" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入山姆订单号",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.jdOrderSn,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "jdOrderSn", $$v)
                          },
                          expression: "listPram.jdOrderSn",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择订单状态",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "status", $$v)
                            },
                            expression: "listPram.status",
                          },
                        },
                        _vm._l(_vm.orderStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "子订单状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择子订单状态",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.childOrderStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "childOrderStatus", $$v)
                            },
                            expression: "listPram.childOrderStatus",
                          },
                        },
                        _vm._l(_vm.subOrderStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "售后状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择售后状态",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.aftersaleStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "aftersaleStatus", $$v)
                            },
                            expression: "listPram.aftersaleStatus",
                          },
                        },
                        _vm._l(_vm.aftersaleStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handerSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单号",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "outOrderSn",
                  label: "第三方订单号",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "jdOrderSn",
                  label: "山姆订单号",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalPrice",
                  label: "订单金额",
                  "min-width": "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.totalPrice != null
                                ? "¥" +
                                    (scope.row.useIntegral +
                                      scope.row.paidPrice)
                                : "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "平台收款", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          ¥" +
                            _vm._s(
                              scope.row.useIntegral + scope.row.paidPrice
                            ) +
                            "\n          "
                        ),
                        _c("div", [
                          _vm._v("福豆：¥" + _vm._s(scope.row.useIntegral)),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("微信：¥" + _vm._s(scope.row.paidPrice)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsAmount",
                  label: "商品总售价",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.goodsAmount != null
                                ? "¥" + scope.row.goodsAmount
                                : "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalFreight",
                  label: "总运费",
                  "min-width": "90",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.totalFreight != null
                                ? "¥" + scope.row.totalFreight
                                : "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "chargeFee",
                  label: "手续费",
                  "min-width": "90",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.chargeFee != null
                                ? "¥" + scope.row.chargeFee
                                : "--"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusDesc",
                  label: "订单状态",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "aftersaleStatusDesc",
                  label: "售后状态",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.aftersaleStatusDesc || "--")),
                        ]),
                        _vm._v(" "),
                        _vm.showAfterSaleViewBtn && _vm.hasAftersale(scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:sam:aftersale:button"],
                                    expression:
                                      "['admin:order:sam:aftersale:button']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openAfterSaleDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            去查看\n          ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "80", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:sam:detail"],
                                expression: "['admin:order:sam:detail']",
                              },
                            ],
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("SamOrderDetail", { ref: "samOrderDetailRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }